export default function imageLoader({ src, width, quality }) {
  return `${
    process.env.NODE_ENV !== 'production' ? 'http://localhost:9999' : ''
  }${src}?w=${width}&q=${quality || 100}`;
}
